import { CardTitle } from "@/components/ui/card";
import { ChevronDown } from "lucide-react";
import ReactMarkdown from "react-markdown";

interface CompanyDescriptionProps {
  companyId: string;
  companyDescription?: {
    de?: string;
    en?: string;
    es?: string;
  };
  expandedCompanies: Set<string>;
  toggleCompanyDescription: (companyId: string) => void;
  getCompanyDescription: (description: {
    de?: string;
    en?: string;
    es?: string;
  }) => string | undefined;
  aboutUsLabel: string;
}

export function CompanyDescription({
  companyId,
  companyDescription,
  expandedCompanies,
  toggleCompanyDescription,
  getCompanyDescription,
  aboutUsLabel
}: CompanyDescriptionProps) {
  if (!companyDescription || !getCompanyDescription(companyDescription)) {
    return null;
  }

  return (
    <div className="mb-6">
      <button
        onClick={() => toggleCompanyDescription(companyId)}
        className="flex items-center gap-2 text-sm font-medium text-gray-900 hover:text-gray-700 transition-colors"
      >
        <CardTitle className="text-lg">{aboutUsLabel}</CardTitle>
        <ChevronDown
          className={`w-4 h-4 transition-transform ${
            expandedCompanies.has(companyId) ? "rotate-180" : ""
          }`}
        />
      </button>
      {expandedCompanies.has(companyId) && (
        <div className="text-gray-700 mt-2 mb-4 space-y-4 [&>ul]:list-disc [&>ul]:pl-5 [&>ol]:list-decimal [&>ol]:pl-5 [&>h1]:text-xl [&>h1]:font-semibold [&>h2]:text-lg [&>h2]:font-semibold [&>h3]:text-base [&>h3]:font-semibold">
          <ReactMarkdown>
            {getCompanyDescription(companyDescription) || ""}
          </ReactMarkdown>
        </div>
      )}
    </div>
  );
}
